var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _path2, _path3, _path4, _g9, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 775,
    height: 748,
    viewBox: "0 0 775 748",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.863 172.054L228.99 201.963L106.551 130.929L160.293 101.021L280.863 172.054Z",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.863 330.01L228.99 359.919L106.551 288.885L160.293 258.977L280.863 330.01Z",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.571 330.01L228.697 359.919L106.258 288.885L160 258.977L280.571 330.01Z",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.99 201.963V359.919",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.761 101.021V258.977L106.604 288.834V130.877",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.867 171.535V329.491",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.606 230.419L125.732 260.328L3.29297 189.295L57.0355 159.386L177.606 230.419Z",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.606 388.375L125.732 418.284L3.29297 347.251L57.0355 317.342L177.606 388.375Z",
    stroke: "#231F20",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.313 388.375L125.44 418.284L3 347.251L56.7425 317.342L177.313 388.375Z",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.732 260.328V418.284",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5036 159.386V317.342L3.3457 347.199V189.243",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.609 229.9V387.857",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611.604 251.033L559.73 280.941L437.291 209.908L491.033 179.999L611.604 251.033Z",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.604 408.989L559.73 438.898L437.291 367.864L491.033 337.955L611.604 408.989Z",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.311 408.989L559.438 438.898L436.998 367.864L490.741 337.955L611.311 408.989Z",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.73 280.942V438.899",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.502 179.999V337.955L437.344 367.812V209.856",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.607 250.514V408.47",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M772.344 340.153L720.471 370.062L598.031 299.028L651.774 269.119L772.344 340.153Z",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.344 498.109L720.471 528.018L598.031 456.984L651.774 427.075L772.344 498.109Z",
    stroke: "#231F20",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.051 498.109L720.178 528.018L597.738 456.984L651.481 427.075L772.051 498.109Z",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.471 370.062V528.018",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.242 269.119V427.075L598.084 456.932V298.976",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.348 339.634V497.59",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.043 144.203L374.916 174.112L497.356 103.079L443.613 73.1699L323.043 144.203Z",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.043 302.16L374.916 332.068L497.356 261.035L443.613 231.126L323.043 302.16Z",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.336 302.16L375.209 332.068L497.649 261.035L443.906 231.126L323.336 302.16Z",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.916 174.112V332.069",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.146 73.1699V231.126L497.304 260.983V103.027",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.043 143.685V301.641",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.883 73.0336L260.756 102.942L383.196 31.9089L329.453 2L208.883 73.0336Z",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.883 230.99L260.756 260.899L383.196 189.865L329.453 159.956L208.883 230.99Z",
    stroke: "#231F20",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.176 230.99L261.049 260.899L383.488 189.865L329.746 159.956L209.176 230.99Z",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.756 102.942V260.899",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.986 2V159.956L383.144 189.813V31.857",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.883 72.5146V230.471",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.834 558.207L382.707 588.116L505.147 517.083L451.404 487.174L330.834 558.207Z",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.834 716.163L382.707 746.072L505.147 675.039L451.404 645.13L330.834 716.163Z",
    stroke: "#231F20",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.127 716.163L383 746.072L505.44 675.039L451.697 645.13L331.127 716.163Z",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.707 588.116V746.073",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.938 487.174V645.13L505.095 674.987V517.031",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.834 557.688V715.645",
    stroke: "white",
    strokeWidth: 2.29202,
    strokeMiterlimit: 10,
    strokeDasharray: "7.59 7.59"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.992 487.364L280.865 517.273L403.305 446.239L349.562 416.33L228.992 487.364Z",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.992 645.32L280.865 675.229L403.305 604.195L349.562 574.286L228.992 645.32Z",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.287 645.32L281.16 675.229L403.6 604.195L349.857 574.286L229.287 645.32Z",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.865 517.272V675.229",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.096 416.33V574.286L403.254 604.143V446.187",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.992 486.845V644.801",
    stroke: "white",
    strokeWidth: 2.29205,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M304.139 360.048C291.941 365.699 288.419 364.263 275.662 368.781C269.021 371.134 258.592 374.828 248.324 383.21C239.905 390.082 230.949 397.392 230.098 409.029C229.354 419.212 235.103 428.78 241.869 434.089C248.121 438.994 253.179 438.645 268.827 442.062C268.828 442.063 282.566 445.062 297.684 450.036C322.521 458.207 323.019 465.95 349.323 475.855C363.143 481.06 372.29 484.37 384.255 482.31C387.052 481.828 402.378 479.19 411.593 466.743C412.938 464.925 414.533 461.329 417.668 454.213C424.728 438.183 428.258 430.169 427.92 426.115C427.103 416.322 419.088 409.696 408.175 400.676C401.826 395.427 395.842 392.24 383.875 385.868C372.973 380.062 367.417 377.151 362.232 376.755C360.063 376.589 355.057 376.459 348.563 374.477C348.563 374.477 345.385 373.506 342.488 372.199C329.297 366.243 326.703 355.12 318.188 353.973C314.303 353.45 313.714 355.613 304.139 360.048Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M572.311 531.291C565.864 537.268 559.605 535.964 550.289 538.885C545.076 540.519 531.117 544.896 528.266 555.212C526.244 562.53 530.14 571.653 536.999 576.095C545.394 581.531 556.572 578.883 562.819 573.817C571.997 566.372 568.545 555.312 578.006 550.275C582.879 547.682 584.532 550.222 591.675 547.618C599.993 544.585 609.782 536.756 608.382 530.152C607.195 524.555 598.437 522.018 594.333 521.419C586.386 520.258 580.169 524.069 578.006 525.595C574.998 527.719 574.825 528.96 572.311 531.291Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M523.329 475.856C520.83 481.942 528.883 486.135 529.404 497.119C529.653 502.356 527.922 503.505 521.051 519.141C515.54 531.681 511.939 539.981 509.66 550.276C508.073 557.446 506.685 563.712 507.382 571.539C508.422 583.227 514.729 605.369 531.682 610.268C547.464 614.828 563.258 601.781 565.855 599.636C571.757 594.761 577.364 587.48 580.283 583.689C587.866 573.843 587.674 571.307 592.434 568.501C597.93 565.262 603.808 565.33 615.215 565.464C626.289 565.593 627.566 567.163 631.162 565.464C638.818 561.848 643.032 550.012 641.034 540.404C638.736 529.353 628.68 523.467 621.29 519.141C611.27 513.276 600.158 510.475 583.321 506.231C574.132 503.915 570.196 503.36 566.614 499.397C561.167 493.369 564.141 487.871 558.261 479.653C557.102 478.033 551.701 470.484 542.314 469.021C535.395 467.943 525.703 470.077 523.329 475.856Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M555.793 510.028C551.05 511.886 551.627 515.339 543.453 522.937C537.361 528.6 536.197 527.466 531.113 532.43C527.796 535.667 521.956 541.369 519.722 550.465C517.734 558.558 519.614 565.211 521.241 570.969C522.904 576.857 524.189 581.404 528.455 585.207C534.008 590.159 540.876 590.426 543.263 590.523C557.632 591.105 567.918 580.005 568.702 579.132C575.686 571.366 573.753 566.01 581.232 560.907C582.373 560.129 582.925 559.907 594.901 556.161C609.894 551.471 612.917 550.602 615.974 547.238C617.058 546.045 620.481 542.168 620.721 536.416C620.992 529.913 617.014 525.36 615.785 524.076C613.045 521.215 609.776 519.778 603.254 518.191C589.581 514.863 587.073 517.072 575.917 514.584C563.536 511.823 561.226 507.899 555.793 510.028Z",
    fill: "white"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M701.832 557.814L536.979 652.864L147.865 427.119L318.659 332.068L701.832 557.814Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M285.252 375.91C272.835 379.451 266.505 381.282 260.572 384.264C250.642 389.253 245.275 391.95 243.106 397.933C240.033 406.409 245.301 416.186 250.7 421.474C258.769 429.376 269.598 429.67 275.38 429.827C295.421 430.371 299.935 419.228 315.628 421.853C325.188 423.453 323.152 427.528 339.169 433.244C349.341 436.874 362.868 441.493 374.86 435.522C377.076 434.419 382.912 431.411 385.871 424.891C390.922 413.764 383.113 402.287 382.454 401.35C378.052 395.09 372.026 392.505 369.545 391.478C360.711 387.821 356.886 390.808 339.169 388.82C331.981 388.014 328.388 387.61 325.12 386.162C314.743 381.564 314.613 374.304 306.515 371.734C304.945 371.236 302.934 370.869 285.252 375.91Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M297.409 388.336C285.016 384.65 273.967 390.673 272.728 391.373C269.228 393.351 265.329 395.553 264.755 399.347C263.936 404.759 270.321 410.51 276.146 412.636C283.044 415.154 289.814 412.826 295.89 410.738C306.054 407.244 307.096 403.55 313.736 403.523C317.542 403.509 320.956 405.096 327.784 408.27C338.137 413.082 340.616 416.554 345.82 415.674C348.936 415.147 352.726 413.111 353.224 410.168C353.713 407.279 350.835 404.653 349.806 403.713C347.227 401.359 344.399 400.435 332.72 398.587C324.397 397.271 323.345 397.347 319.241 396.309C315.301 395.313 312.199 394.214 309.559 393.272C301.301 390.324 301.111 389.437 297.409 388.336Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M566.059 549.541C564.421 549.076 563.195 548.729 561.849 548.348C564.376 544.23 566.826 540.237 569.376 536.083C568.073 535.756 566.997 535.485 565.739 535.169C568.099 530.778 570.412 526.475 572.828 521.98C571.358 521.764 570.143 521.586 568.497 521.344C573.729 513.955 576.767 505.696 579.919 496.993C583.205 505.598 586.07 513.937 591.453 521.341C589.807 521.575 588.553 521.754 587.051 521.968C589.459 526.423 591.767 530.692 594.177 535.151C592.987 535.452 591.92 535.721 590.506 536.079C593.048 540.209 595.522 544.228 598.066 548.363C596.676 548.749 595.447 549.09 593.841 549.537C597.057 554.121 600.149 558.526 603.535 563.352H583.277V579.288H576.682V563.467H556.289C559.705 558.598 562.799 554.188 566.059 549.541Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 4.58409,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M522.836 573.941C520.076 573.159 518.012 572.574 515.745 571.931C520.001 564.996 524.128 558.271 528.422 551.275C526.228 550.724 524.415 550.268 522.296 549.736C526.271 542.341 530.166 535.094 534.235 527.523C531.76 527.159 529.713 526.859 526.942 526.451C535.754 514.006 540.869 500.097 546.179 485.439C551.713 499.932 556.538 513.977 565.604 526.446C562.832 526.841 560.721 527.141 558.19 527.502C562.247 535.006 566.133 542.195 570.193 549.705C568.189 550.212 566.392 550.666 564.01 551.268C568.291 558.223 572.457 564.992 576.743 571.957C574.401 572.607 572.332 573.182 569.626 573.934C575.043 581.655 580.25 589.074 585.953 597.202H551.835V624.042H540.727V597.395H506.381C512.133 589.195 517.345 581.768 522.836 573.941Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 4.58409,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M436.135 398.222C433.375 397.44 431.311 396.855 429.043 396.212C433.299 389.278 437.427 382.553 441.721 375.556C439.527 375.005 437.713 374.55 435.595 374.018C439.57 366.622 443.465 359.375 447.534 351.804C445.058 351.441 443.012 351.14 440.241 350.733C449.053 338.288 454.168 324.379 459.478 309.721C465.012 324.213 469.837 338.259 478.903 350.727C476.131 351.122 474.02 351.423 471.489 351.783C475.545 359.287 479.432 366.477 483.491 373.986C481.487 374.493 479.69 374.947 477.309 375.549C481.59 382.505 485.755 389.274 490.042 396.238C487.7 396.888 485.631 397.463 482.924 398.215C488.342 405.936 493.548 413.355 499.252 421.483H465.134V448.323H454.026V421.676H419.68C425.432 413.477 430.643 406.049 436.135 398.222Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 4.58409,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M410.999 442.699C409.36 442.235 408.134 441.887 406.788 441.506C409.315 437.388 411.766 433.395 414.315 429.241C413.013 428.914 411.936 428.644 410.678 428.328C413.038 423.937 415.351 419.634 417.767 415.138C416.297 414.922 415.082 414.744 413.437 414.502C418.669 407.113 421.706 398.855 424.859 390.151C428.145 398.756 431.009 407.096 436.392 414.499C434.746 414.733 433.493 414.912 431.99 415.126C434.399 419.581 436.706 423.85 439.117 428.309C437.927 428.61 436.86 428.88 435.446 429.237C437.988 433.367 440.461 437.386 443.006 441.521C441.616 441.907 440.387 442.248 438.78 442.695C441.997 447.279 445.088 451.684 448.475 456.51H428.217V472.446H421.622V456.625H401.229C404.644 451.756 407.738 447.346 410.999 442.699Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 4.58409,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M283.987 375.27C281.563 374.584 279.75 374.07 277.759 373.505C281.497 367.415 285.121 361.509 288.893 355.364C286.966 354.88 285.373 354.48 283.513 354.013C287.004 347.518 290.425 341.154 293.998 334.505C291.824 334.185 290.026 333.921 287.593 333.563C295.332 322.634 299.824 310.418 304.488 297.545C309.348 310.273 313.586 322.608 321.547 333.559C319.113 333.905 317.259 334.169 315.036 334.486C318.599 341.076 322.012 347.39 325.577 353.986C323.817 354.431 322.239 354.83 320.148 355.358C323.907 361.467 327.566 367.412 331.33 373.528C329.273 374.099 327.456 374.604 325.079 375.264C329.837 382.045 334.41 388.561 339.419 395.699H309.455V419.271H299.7V395.869H269.535C274.587 388.668 279.164 382.145 283.987 375.27Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 4.58409,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M248.905 389.785C246.145 389.002 244.08 388.417 241.813 387.775C246.069 380.84 250.196 374.115 254.49 367.119C252.296 366.568 250.483 366.112 248.365 365.58C252.34 358.185 256.235 350.938 260.304 343.367C257.828 343.003 255.781 342.702 253.011 342.295C261.822 329.85 266.938 315.941 272.248 301.283C277.781 315.776 282.607 329.821 291.672 342.29C288.9 342.685 286.789 342.985 284.259 343.345C288.315 350.849 292.202 358.039 296.261 365.549C294.257 366.055 292.46 366.51 290.079 367.112C294.359 374.067 298.525 380.836 302.811 387.801C300.469 388.451 298.4 389.026 295.694 389.778C301.112 397.498 306.318 404.918 312.021 413.045H277.903V439.885H266.796V413.238H232.449C238.202 405.039 243.413 397.612 248.905 389.785Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 4.58409,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.349d8c33dc3bd05380d446ce98575ec7.svg";
export { ForwardRef as ReactComponent };